import { createContext } from 'react';

import type { FormRuntime } from '../runtime/createFormRuntime.js';

/**
 * Carries the enclosing form runtime down to the controls that register with
 * it. `undefined` when a control is rendered outside any `<Form>` — controls
 * degrade gracefully to standalone behavior in that case.
 * @internal
 */
export interface FormContextValue {
  /** The runtime the nearest `<Form>` created. */
  runtime: FormRuntime;
  /** The nearest `<Form>`'s `id`, if it set one. */
  formId?: string;
  /** Stable ID shared with `FormMessages` so fields can point aria-describedby at it. */
  formMessagesId: string;
}

/**
 * @internal
 */
export const FormContext = createContext<FormContextValue | undefined>(
  undefined,
);
